import request from '@/utils/request'

export function findCpeInventories(params) {
  return request({
    url: `/cpe_inventories`,
    method: 'get',
    params
  })
}

// CPE 入库
export function importCpeInventories(data) {
  return request({
    url: `/cpe_inventories/import`,
    method: 'post',
    data
  })
}

// CPE 重新入库
export function reImportCpeInventories(data) {
  return request({
    url: `/cpe_inventories/re_import`,
    method: 'post',
    data
  })
}

// 导出库存 CPE
export function exportCpeInventories(data) {
  return request({
    url: `/cpe_inventories/export`,
    method: 'post',
    data
  })
}

// 删除库存 CPE
export function destroyCpeInventories(data) {
  return request({
    url: `/batch_operations/cpe_inventories`,
    method: 'delete',
    data
  })
}

// CPE 型号库存统计
export function findCpeInventoryStatistics(params) {
  return request({
    url: `/cpe_inventories/statistics`,
    method: 'get',
    params
  })
}

// CPE 库存告警设置
export function setCpeInventoryAlarm(cpeModelId, data) {
  return request({
    url: `/cpe_inventories/statistics/${cpeModelId}/set_alarm`,
    method: 'post',
    data
  })
}
